<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
        <path fill="#4de0f9" d="M34.5 43H25v-3.1h7.9zM33.9 10.2h2.8v8.4h-2.8zM37.6 19.6v15.5L36 38.7l1.2 2.9c.1.1.3.1.4 0l2-4.5V19.6h-2z"/>
        <path fill="#0d5fc3" d="M34.3 42.3H13.8V8.4H36v8.5h-1.2V9.6H15v31.5h19.3z"/>
        <path fill="#0d5fc3" d="M24.8 13.7h5.9v1.2h-5.9zM19.3 13.7h3.3v1.2h-3.3zM19.3 17.3h11.3v1.2H19.3zM28.3 20.9h2.3v1.2h-2.3zM19.3 20.9h6.8v1.2h-6.8zM25.9 24.5h4.7v1.2h-4.7zM19.3 24.5h4.2v1.2h-4.2zM19.3 28.1h11.3v1.2H19.3z"/>
        <path fill="#0d5fc3" d="M25.9 31.7h4.7v1.2h-4.7zM19.3 31.7h4.2v1.2h-4.2zM19.3 35.3h11.3v1.2H19.3z"/>
        <path fill="#0d5fc3" d="M39.2 36.7h-5.5V18h5.5v18.7zm-4.3-1.2H38V19.2h-3.1v16.3z"/>
        <path fill="#0d5fc3" d="M36.4 41.3c-.3 0-.6-.2-.7-.4l-1.9-4.5 1.1-.5 1.6 3.6 1.6-3.6 1.1.5-2 4.5c-.2.2-.5.4-.8.4z"/>
        <path fill="#4de0f9" d="M35.6 29.4h1.1v2.8h-1.1z"/>
        <path fill="#4de0f9" d="M35.6 32.8h1.1v1.1h-1.1z"/>
    </svg>
</template>
<script>
// https://www.iconfinder.com/iconsets/message-and-communication-sets
export default {

};
</script>
